var _defs, _path, _path2, _path3, _line, _line2, _line3, _line4, _path4, _path5, _path6, _path7, _line5, _line6, _line7, _line8, _line9, _path8, _path9, _path10, _path11, _polyline, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifestyleSliderBackpainIconWhite2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-backpain-slider-white{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M29.91,19.31a40.32,40.32,0,0,1,4.78,19.13c-.28,10.4-4.5,17.15-8.72,23.9S20.06,73.87,19.78,79.5s0,19.12,0,19.12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M20.59,74s6.5,1.56,15.79,7.19S52.13,91.31,52.13,91.31h4.56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M92.2,74s-6.5,1.56-15.78,7.19S60.67,91.31,60.67,91.31H56.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 29.91,
    y1: 19.31,
    x2: 28.05,
    y2: 58.97
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 18.45,
    y1: 15.74,
    x2: 20.9,
    y2: 72.86
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 51.56,
    y1: 92.53,
    x2: 49.59,
    y2: 100.97
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 60.59,
    y1: 92.53,
    x2: 62.56,
    y2: 100.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.44,62.34c4.22,6.75,5.91,11.54,6.19,17.16s0,19.13,0,19.13"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M29.91,19.31a40.32,40.32,0,0,1,4.78,19.13c-.28,10.4-4.5,17.15-8.72,23.9S20.06,73.87,19.78,79.5s0,19.12,0,19.12"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M20.59,74s6.5,1.56,15.79,7.19S52.13,91.31,52.13,91.31h4.56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M92.2,74s-6.5,1.56-15.78,7.19S60.67,91.31,60.67,91.31H56.1"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 29.91,
    y1: 19.31,
    x2: 28.05,
    y2: 58.97
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 18.45,
    y1: 15.74,
    x2: 20.9,
    y2: 72.86
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 56.1,
    y1: 47.77,
    x2: 56.1,
    y2: 19.31
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 51.56,
    y1: 92.53,
    x2: 49.59,
    y2: 100.97
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1-backpain-slider-white",
    x1: 60.59,
    y1: 92.53,
    x2: 62.56,
    y2: 100.97
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.05,62.54c2.9,5.78,6.4,13.43,6.58,17,.28,5.63,0,19.13,0,19.13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M26,62.34s23,3,30.72,3c10.62,0,22.14-2.16,25.72-2.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M83.51,19.31s-5.07,8-4.78,17.61a20.69,20.69,0,0,0,1,7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M87.15,49.62a9.39,9.39,0,0,1,.55,4.78c-.33,2.8.46,5.58-1.64,5.33-1.22-.14-2-4-2.55-5.33-2.82,2.65-7,7.23-9.36,5.69a7.55,7.55,0,0,1-2-10.67c2-2.83,7.21-5.3,9.76-5.46"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1-backpain-slider-white",
    points: "82.34 13.94 95.36 21.54 82.89 44.09"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1-backpain-slider-white",
    d: "M90.56,5.2l8.1,5.44s6,5.2,6.35,6.68a29.79,29.79,0,0,1,0,5.8L88.72,49.68"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyleSliderBackpainIconWhite2);
export default __webpack_public_path__ + "static/media/lifestyle_slider_backpain_icon_white_2.3c4dbbca.svg";
export { ForwardRef as ReactComponent };